<ng-container *transloco="let t; prefix: 'login'">
    <div class="container py-5">
        <div class="d-flex justify-content-center">
            <div class="overlay-spinner">
                <div class="visually-hidden">{{ t("loadingtext") }}</div>
                <loading-spinner-grow />
            </div>
        </div>
    </div>
</ng-container>